<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetayParametreTanim from "@/models/strperftablolardetayparametretanim";
import AddEdit from "./AddEdit.vue";

export default {
  mixins: [Api, Sabit, StrPerfTablolarDetayParametreTanim],
  page: {
    title: "Detay parametre Tanımları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("StrPerfTablolarDetayParametreTanim.Title"),
      items: [
        {
          text: this.$t("StrPerfTablolarDetayParametreTanim.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrPerfTablolarDetayParametreTanim.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrPerfTablolarDetayParametreTanim.Title"),
          active: true,
        },
      ],
      islem: "",
      TableData: [],
      DataUpdate: "",
      AddEdit: "",
      FormTitle: "",
      FilitrelemePenceresi: false,
      Filter: {
        Parametreadi: "",
      },
      siralama:"&Asc=Parametreadi",

      DefaultPage: 1,

      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },

  methods: {
    Get() {
       
       let Filter="";
       

       if (this.Filter.Parametreadi != "" && this.Filter.Parametreadi != null) {
      
          Filter = Filter + "&Parametreadi=" + this.Filter.Parametreadi;
        }

        
        if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

        this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreTanim", Page: this.Page, Filter: Filter }).then((res) => {

        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input type="text" @input="Filter.Parametreadi.length >= 3 || Filter.Parametreadi.length == 0 ? Get() : ''" 
                    v-model="Filter.Parametreadi" class="form-control" placeholder="Arama..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i class="mdi mdi-text-search me-1"></i> {{ this.$t("StrPerfTablolarDetayParametreTanim.Page.Filtreleme") }}</button>

                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrPerfTablolarDetayParametreTanim @click="(DataUpdate = StrPerfTablolarDetayParametreTanimData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ this.$t("StrPerfTablolarDetayParametreTanim.Page.YeniKayitEkle") }}</button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">{{ this.$t("StrPerfTablolarDetayParametreTanim.Table.Parametreadi") }}
                     <i style="margin-left:10px" v-if="siralama!='&Asc=Parametreadi'" @click="siralama='&Asc=Parametreadi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Parametreadi'" @click="siralama='&Desc=Parametreadi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                    <th scope="col">{{ this.$t("StrPerfTablolarDetayParametreTanim.Table.tipValue") }}
                     <i style="margin-left:10px" v-if="siralama!='&Asc=tipValue'" @click="siralama='&Asc=tipValue', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=tipValue'" @click="siralama='&Desc=tipValue', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                    <th style="width: 85px; text-align: center; vertical-align: middle;">{{ this.$t("StrPerfTablolarDetayParametreTanim.Table.Islem") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="Data in TableData" :key="Data.Id">
                    <td>{{ Data.Parametreadi }}</td>

                    <td>{{ Data.tipValue }}</td>
                    <td style="width: 85px; text-align: center; vertical-align: middle;">

                      <b-button-group>
                          <b-button variant="success" v-b-modal.StrPerfTablolarDetayParametreTanim @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="fas fa-pencil-alt"></i></b-button>
                          <b-button variant="danger" @click="Delete('StrPerfTablolarDetayParametreTanim', Data.Id)"><i class="fas fa-trash-alt"></i></b-button>
                      </b-button-group>

                    </td>
                  </tr>
                </tbody>
              </table>

              <br />

              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrPerfTablolarDetayParametreTanim.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrPerfTablolarDetayParametreTanim.Filtreleme.Content") }}
            <hr />
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfTablolarDetayParametreTanim.Filtreleme.Parametreadi") }}</label>
              <b-form-input  @input="Filter.Parametreadi.length >= 3 || Filter.Parametreadi.length == 0 ? Get() : ''" v-model="Filter.Parametreadi" for="text" value=""></b-form-input>
            </div>

            <b-button @click="Get,rightDrawer()" class="btn btn-primary" variant="primary">{{ $t("StrPerfTablolarDetayParametreTanim.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
